import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';
import { useCallback } from 'react';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { isNil } from 'shared/src/utils';

export const useLogClickBrandHome = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const { data: goodsBasic } = useGoodsBasic();

  // type: 클릭이 발생한 브랜드 UI 종류 (native 정합).
  // - 'SIMPLE': 심플 배너(MarketInfoBanner)
  // - 'BRAND_INFORMATION': 브랜드 정보 행(BrandInfo)
  return useCallback(
    (type: 'SIMPLE' | 'BRAND_INFORMATION' = 'SIMPLE') => {
      if (isNil(goodsBasic)) return;
      if (isNil(goodsBasic.brand)) return;

      logGoodsAnalytics({
        name: 'CLICK_BRAND_HOME',
        analytics: {
          BRAND_NAME: goodsBasic.brand.name,
          BRAND_SNO: goodsBasic.brand.sno.toString(),
          GOODS_SNO: goodsBasic.sno.toString(),
          MARKET_NAME: goodsBasic.market.name,
          MARKET_SNO: goodsBasic.market.sno.toString(),
          MARKET_TYPE: goodsBasic.brand.brand_vertical_type.name,
          MARKET_TYPE_SNO: goodsBasic.brand.brand_vertical_type.sno.toString(),

          TYPE: type,
        },
      });
    },
    [goodsBasic, logGoodsAnalytics],
  );
};
